import React from 'react';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import Title from 'antd/es/typography/Title';

interface SectionProps {
  title: string;
  subtitle?: string;
  links?: Array<{url?: string; linkLabel: string}>;
  className?: string;
  contentClassName?: string;
  children?: React.ReactNode;
}

export const Section: React.FC<SectionProps> = ({title, subtitle, links, className, contentClassName, children}) => {
  return (
    <div className={classNames('flex flex-col mb-8', className)}>
      <div className="flex justify-between">
        <Title level={5}>{title}</Title>
        <div>
          {links &&
            links.map((link) => (
              <Link
                key={link.linkLabel}
                to={link.url ?? ''}
                type="internal"
                className="text-12 leading-4 text-blue ml-2"
              >
                {link.linkLabel}
              </Link>
            ))}
        </div>
      </div>
      {subtitle && <span className="text-12 leading-4 mb-3">{subtitle}</span>}
      <div className={classNames('w-full h-full', contentClassName)}>{children}</div>
    </div>
  );
};
